import { CreateAircraftGroupScheduleAction, reloadAirGroupSchedule, setState } from '../actions';
import api from '../../../../../../../../services/api';
import { call, put, select } from 'redux-saga/effects';
import { getCompanyID } from '../../../../../../../../redux/selectors';
import { reloadCrewScheduleAfterActionWorker } from './reloadCrewScheduleAfterActionWorker';

export function* createGroupScheduleWorker(action: CreateAircraftGroupScheduleAction) {
  const { payload } = action;
  const companyID = yield select(getCompanyID);

  const data = payload;

  try {
    yield put(setState({ isCrewUpdateEntryRequest: true }));
    yield call(api.post, `/v1/companies/${companyID}/group-schedule`, data);
    yield put(setState({ isModalOpen: false }));

    yield call(reloadCrewScheduleAfterActionWorker);
  } catch (err) {
    console.log(err);
  } finally {
    yield put(setState({ isCrewUpdateEntryRequest: false }));
  }
}
